export default {
    props: {
        localizationCancel: {
            type: String,
            kComposite: 'localization.cancel'
        }, 
        localizationClearSelectedFiles: {
            type: String,
            kComposite: 'localization.clearSelectedFiles'
        }, 
        localizationDropFilesHere: {
            type: String,
            kComposite: 'localization.dropFilesHere'
        }, 
        localizationHeaderStatusUploaded: {
            type: String,
            kComposite: 'localization.headerStatusUploaded'
        }, 
        localizationHeaderStatusUploading: {
            type: String,
            kComposite: 'localization.headerStatusUploading'
        }, 
        localizationInvalidFileExtension: {
            type: String,
            kComposite: 'localization.invalidFileExtension'
        }, 
        localizationInvalidFiles: {
            type: String,
            kComposite: 'localization.invalidFiles'
        }, 
        localizationInvalidMaxFileSize: {
            type: String,
            kComposite: 'localization.invalidMaxFileSize'
        }, 
        localizationInvalidMinFileSize: {
            type: String,
            kComposite: 'localization.invalidMinFileSize'
        }, 
        localizationRemove: {
            type: String,
            kComposite: 'localization.remove'
        }, 
        localizationRetry: {
            type: String,
            kComposite: 'localization.retry'
        }, 
        localizationSelect: {
            type: String,
            kComposite: 'localization.select'
        }, 
        localizationStatusFailed: {
            type: String,
            kComposite: 'localization.statusFailed'
        }, 
        localizationStatusUploaded: {
            type: String,
            kComposite: 'localization.statusUploaded'
        }, 
        localizationStatusUploading: {
            type: String,
            kComposite: 'localization.statusUploading'
        }, 
        localizationUploadSelectedFiles: {
            type: String,
            kComposite: 'localization.uploadSelectedFiles'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Localization.js